import { render } from "./Invites.vue?vue&type=template&id=703770d3"
import script from "./Invites.vue?vue&type=script&lang=js"
export * from "./Invites.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__